import {
  SoftwareOnboardingLayout,
  SoftwareOnboardingMain,
  SoftwareOnboardingHeader,
  SoftwareOnboardingFooter,
  SoftwareOnboardingProgress,
  TripartiteAgreementNotice,
} from 'src/components/SoftwareOnboarding';
import { AppProductTypeEnum } from 'src/graphql/schema';
import { withSuspense } from 'src/hoc';
import { AppContextProvider, useApp } from 'src/context/app';
import { AppLinkBanner } from 'src/widgets/AppLinkBanner';

import { SoftwareEscrowNewContextProvider } from './model';
import { AgreementFormSettings, CreateAction, ExitAlertDialog } from './ui';

const SoftwareEscrowOnboardingNewContent = () => {
  const { app } = useApp();
  const appName = app.name ?? 'Untitled Application';

  return (
    <SoftwareEscrowNewContextProvider>
      <SoftwareOnboardingLayout>
        <SoftwareOnboardingHeader>
          <SoftwareOnboardingProgress currentStep={1} totalSteps={10} productType={AppProductTypeEnum.SoftwareEscrow} />
          <ExitAlertDialog />
        </SoftwareOnboardingHeader>
        <SoftwareOnboardingMain
          subtitle="Agreement type"
          title="Create your new escrow"
          description={
            app.owned
              ? "Start by choosing your agreement form. You won't be able to change this later, so take a moment to review before continuing."
              : "Here's how this escrow will be set up. You won't be able to change this once you save, so take a moment to review before continuing."
          }
        >
          <div className="max-w-260 w-full mx-auto space-y-4">
            <AppLinkBanner
              app={app}
              title={`This protection is linked to ${appName}`}
              description={`Everyone with access to ${appName} will be able to see this protection. This link is permanent, so you can't attach it to a different application later. Check this is the right one before you continue.`}
            />
            {app.owned ? <AgreementFormSettings /> : <TripartiteAgreementNotice />}
          </div>
        </SoftwareOnboardingMain>
        <SoftwareOnboardingFooter justify="end">
          <CreateAction />
        </SoftwareOnboardingFooter>
      </SoftwareOnboardingLayout>
    </SoftwareEscrowNewContextProvider>
  );
};

const SoftwareEscrowOnboardingNew = () => (
  <AppContextProvider>
    <SoftwareEscrowOnboardingNewContent />
  </AppContextProvider>
);

export default withSuspense(SoftwareEscrowOnboardingNew);
